// Saves an appearance change to the signed-in user's profile. Bullet Train
// announces every change, from the switch or from Account Details, on window.
// Saves are sent one after another so quick successive changes land in order.
let pendingSave = Promise.resolve()

window.addEventListener("color-scheme:changed", (event) => {
  const url = document.querySelector('meta[name="color-scheme-profile-url"]')?.content
  const colorScheme = event.detail?.colorScheme
  if (!url || !colorScheme) return

  pendingSave = pendingSave.then(() => fetch(url, {
    method: "PATCH",
    credentials: "same-origin",
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
    },
    body: JSON.stringify({color_scheme: colorScheme})
  })).catch(() => {})
})
